import React from 'react'
import { Modal, Button } from 'antd'

import './delete.css'

const ConfirmModal = props => {
  const handleOk = () => {
    if (props.handleSuccess) props.handleSuccess()
  }

  const handleCancel = () => {
    if (props.handleCancel) props.handleCancel()
  }

  return (
    <Modal
      title=''
      visible={!!props.visible}
      onOk={handleOk}
      onCancel={handleCancel}
      afterClose={props.afterClose}
      destroyOnClose
      maskClosable={false}
      className='delete-modal'
      footer={[
        <Button key='delete' type='primary' onClick={handleOk} loading={props.loading || false}>
          {props.okText}
        </Button>,
        <Button key='cancel' onClick={handleCancel}>
          {props.cancelText}
        </Button>
      ]}>
      <h2 className='text-center title'>{props.title}</h2>
      <p className='text'>{props.description}</p>
    </Modal>
  )
}

export default ConfirmModal
